
<!-- hero-header 11 -->
<section class="w3l-hero-headers-11 p-sticky-md">
    <div class="hero-header-11">
        <div class="hero-header-11-content">

            <div class="main-header">
                <div class="wrapper-full">
                    <div class="d-grid grid-columns-auto">
                        <div class="right-grid align-left d-grid">
                            <div class="quick-links">
                                <ul>
                                    <li>
                                        <span class="fa fa-phone" aria-hidden="true"></span>
                                        <a href="tel:+(202) 3302-6814"> +(202) 3304-6767 - +(202) 3302-6814</a>
                                    </li>
                                    <li>
                                        <span class="fa fa-user" aria-hidden="true"></span>

                                        <label>{{userName}}</label>
                                    </li>
                                    <li>

                                        <img src="data:image/jpg;base64,{{myimage}}" class="img-circle" alt="User Image" width="50px" height="50px"/>


                                    </li>
                                </ul>
                            </div>
                            <div class="button align-right">

                                <img src="assets/images/NewLogo.jpg" style="width:130px;height: 100px;" alt="" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- //hero-header 11 -->
<!-- Headers-4 block -->
<section class="w3l-header-4" >
    <header id="headers4-block"  style="background-color: #0156a7;">
        <div class="wrapper-full">
            <div class="d-grid nav-mobile-block header-align" style="background-color: #0156a7;">
                <div class="logo">
                    <a class="brand-logo" href="index.html" style="font-family:Arial, Helvetica, sans-serif;font-size: 250%;font-weight: bolder;">{{CompanyName}}</a>
                    <!-- if logo is image enable this
                          <a class="brand-logo" href="#index.html">
                              <img src="image-path" alt="Your logo" title="Your logo" style="height:35px;" />
                          </a> -->
                          <label style="width: 30%;">                                                  </label>
                          <a class="brand-logo" href="" (click)="Log_Out()">
                          <label   style="width: 20%;color: white;font-weight: bold;cursor: grab;font-size: medium;">Logout</label>
                          </a>
                </div>
                <input type="checkbox" id="nav" />
                <label class="nav" for="nav"></label>
                <nav >
                    <label for="drop" class="toggle nav-height">Menu
                        <!-- <span class="fa fa-bars"aria-hidden="true"></span> -->
                    </label>
                    <input type="checkbox" id="drop">
                    <ul class="menu" >
                        <li><a href="Home" style="background-color: #0156a7;">Home</a></li>
                        <li>
                            <!-- sumenu Drop Down -->
                            <label *ngIf="!wk_Not"for="drop-3" class="toggle toogle-3" [hidden]="wk_Not" >Admin <span class="angle-dropdown" aria-hidden="true"></span>
                            </label>
                            <a  *ngIf="!wk_Not"  >Admin<span class="angle-dropdown" aria-hidden="true"></span></a>
                            <input type="checkbox" id="drop-3" >

                            <ul style="background-color: #0156a7;width: 200px;">
                                <li><a href="Doctors" class="drop-text" (click)="Doctors()">Doctors</a></li>
                                <li><a href="Codes" class="drop-text" (click)="Supplier()" >Medical Suppliers</a></li>
                                <li><a href="Rooms" class="drop-text">Treatment Rooms</a></li>
                                 <li><a href="InsuranceCompany" class="drop-text">Insurance Companies</a></li>
                                <li><a href="Users" class="drop-text">Users</a></li>
                                <li><a href="user-perm" class="drop-text">Users Permissions</a></li>
                                <li><a href="report-admin" class="drop-text">Report</a></li>
                            </ul>
                        </li>
                        <li *ngIf="!wk_Oncology_Not">
                            <!-- First Tier Drop Down -->
                            <label *ngIf="!wk_Oncology_Not" for="drop-4" class="toggle toogle-4">Patient's Data bank <span class="angle-dropdown"aria-hidden="true"></span></label>
                            <a  *ngIf="!wk_Oncology_Not">Patient's Data bank <span class="angle-dropdown" aria-hidden="true"></span></a>
                            <input type="checkbox" id="drop-4">

                            <ul style="background-color: #0156a7;width: 200px;">
                                <li><a href="PatientReservation" class="drop-text" (click)="Dbank()" >Daily Reservation</a></li>
                                <!-- <li><a href="DoctorObservation" (click)="DoctorObservation()" class="drop-text">Medical Records</a></li> -->
                                <li><a href="DoctorObservationTab" (click)="DoctorObservation()" class="drop-text">Medical Records</a></li>
                                <li><a  (click)="ClinicalPharmacyFollowUp()" class="drop-text" style="cursor: grab;">Clinical Pharmacy Report</a></li>
                                <li><a href="annex" class="drop-text">Annex</a></li>
                                <li><a href="TTTFollowUp" class="drop-text">TTT Follow Up</a></li>
                                <li><a href="report-medical" class="drop-text">Reports</a></li>

                            </ul>
                        </li>
                        <li>
                            <!-- Pharmacy Drop Down -->
                            <label for="drop-9" class="toggle toogle-9">Pharmacy <span class="angle-dropdown"
                                    aria-hidden="true"></span>
                            </label>
                            <a  *ngIf="!wk_Pharma_Not" >Pharmacy <span class="angle-dropdown" aria-hidden="true"></span></a>
                            <input type="checkbox" id="drop-9">

                            <ul style="background-color: #0156a7;width: 200px;">
                                <li><a href="PatientReservation" class="drop-text">Daily Reservation Status</a></li>
                                <li><a *ngIf="!wk_Pharma_Not" href={{wk_preparationOrderLink}} class="drop-text" (click)="Prep_Order()">Clinical Pharmacy</a></li>
                                                                <li><a href="roundandclinic" class="drop-text">Round And Clinic</a></li>
                                <li><a  (click)="ClinicalPharmacyFollowUp()" class="drop-text" style="cursor: grab;">Clinical Pharmacy Report</a></li>
                                <li><mat-divider></mat-divider></li>
                                <li><a href="Units" class="drop-text">Units</a></li>
                                <li><a href="Items" class="drop-text">Items</a></li>
                                <li><a href="TraetmentGroup" class="drop-text">Traetment Group</a></li>
                                <li><a href="Protocols" class="drop-text">Protocols</a></li>
                                <li><a href="report-Pharma" class="drop-text">Reports</a></li>

                            </ul>
                        </li>
                        <li>
                            <!-- Booking Drop Down -->
                            <label for="drop-5" class="toggle toogle-5">Booking <span class="angle-dropdown"
                                    aria-hidden="true"></span>
                            </label>
                            <a *ngIf="!wk_Staff_Not" >Booking <span class="angle-dropdown" aria-hidden="true"></span></a>
                            <input type="checkbox" id="drop-5">

                            <ul style="background-color: #0156a7;width: 220px;">
                                <li><a href="PatientReservation" class="drop-text">Daily Reservation Status</a></li>
                                <li><a href="Booking" class="drop-text">Treatment Booking</a></li>
                                <li><a href="BookingDoctor" class="drop-text">Consultation Booking</a></li>
                                <li><mat-divider></mat-divider></li>
                                <li><a href="Dbank" class="drop-text" (click)="Dbank()" >Personal Data</a></li>
                                <li><a href="PatientDocumentNew" target="_blank">Invistgations (Attachments)</a></li>
                                <li><a href="VacationRequest" class="drop-text">Doctors Vacations</a></li>
                                <li><a href="search-adv" class="drop-text">Advanced search</a></li>
                                <li><mat-divider></mat-divider></li>
                                <li><a href="report-booking" class="drop-text">Reports</a></li>
                            </ul>
                        </li>
                        <li>
                            <!-- First Tier Drop Down -->
                            <label for="drop-8" class="toggle toogle-8">Accounting <span class="angle-dropdown"
                                    aria-hidden="true"></span>
                            </label>
                            <a *ngIf= "!wk_Acc_Not" >Accounting <span class="angle-dropdown" aria-hidden="true"></span></a>
                            <input type="checkbox" id="drop-8">

                            <ul style="background-color: #0156a7;">
                                <li><a href="AccMaster" class="drop-text">Master Files</a></li>
                                <li><a href="AccTransactions" class="drop-text">Transactions</a></li>
                                <li><a href="AccReports" class="drop-text">Reports</a></li>
                            </ul>
                        </li>
                        <li>
                          <label for="drop-8" class="toggle toogle-8">Accounting <span class="angle-dropdown"
                            aria-hidden="true"></span>
                    </label>
                    <a  >Contacts <span class="angle-dropdown" aria-hidden="true"></span></a>
                    <input type="checkbox" id="drop-8">

                    <ul style="background-color: #0156a7;">
                        <li><a href="ContClass" class="drop-text">Classification</a></li>
                        <li><a href="ContCategory" class="drop-text">Categories</a></li>
                        <li><a href="Contacts" (click)="Contacts()" class="drop-text">Data Bank</a></li>
                        <li><a href="ContactSearchAdv" class="drop-text">Contacts Search</a></li>
                    </ul>
                    </ul>
                </nav>
            </div>
        </div>
    </header>
    <div style="background-color: #7cbc44;width: 100%;align-content:center ;padding-left: -5%;">
      <label style="background-color: #7cbc44;width: 100%;align-content:center ;padding-left: -5%;">               </label>
    </div>
</section>
